import styled from 'styled-components';
import { Typography } from '@mui/material';

export const ErrorMessage = styled(Typography)`
  display: block;
  color: #ea170b;
  font-size: 0.875rem;
`;
